import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { MiViewColors, MiViewFontSize, MiViewSpacing } from 'miview-ui/miviewTheme';

export const sortIconStyle: SxProps<Theme> = {
  color: MiViewColors.tertiary,
  fontSize: MiViewFontSize.large,
  marginRight: MiViewSpacing.xxSmall,
  width: '24px',
  height: '24px',
};

export const filterListIconStyle: SxProps<Theme> = {
  color: MiViewColors.orange,
  fontSize: MiViewFontSize.large,
  marginRight: MiViewSpacing.xxSmall,
  width: '24px',
  height: '24px',
};

export const moreVertIconStyle: SxProps<Theme> = {
  color: MiViewColors.royalBlack,
  fontSize: MiViewFontSize.large,
  width: '24px',
  height: '24px',
};

export const boxStyle: SxProps<Theme> = {
  position: 'relative',
  top: '30%',
  textAlign: 'center',
  color: MiViewColors.secondary,
  fontSize: MiViewFontSize.xxxLarge,
};

export const menuButtonStyle: SxProps<Theme> = {
  minWidth: '38px',
  maxWidth: '38px',
  marginRight: MiViewSpacing.xxSmall,
  borderRadius: '40px',
  '&:hover': {
    background: 'rgba(0, 0, 0, 0.04)',
  },
};
